// @ts-nocheck
export const localeCodes =  [
  "en",
  "he"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_661b6c44",
      load: () => import("#nuxt-i18n/661b6c44" /* webpackChunkName: "locale_en_46json_661b6c44" */),
      cache: true
    }
  ],
  he: [
    {
      key: "locale_he_46json_1c862fe9",
      load: () => import("#nuxt-i18n/1c862fe9" /* webpackChunkName: "locale_he_46json_1c862fe9" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/949ed66c" /* webpackChunkName: "config_i18n_46config_46ts_949ed66c" */)
]
export const normalizedLocales = [
  {
    code: "en",
    dir: "ltr",
    language: undefined
  },
  {
    code: "he",
    dir: "rtl",
    language: undefined
  }
]
/** client **/

/** client-end **/